import React from "react";
import { MessageCircle } from "lucide-react";
import { trackEvent } from "../../lib/analytics";

export const FloatingWhatsApp = () => {
  return (
    <a
      data-testid="whatsapp-fab"
      aria-label="Chat with Dr. Shalini's team on WhatsApp"
      href="https://wa.me/919133552279?text=Hi%20Dr.%20Shalini%2C%20I%27d%20like%20to%20know%20about%20Mounjaro%20weight%20loss."
      target="_blank"
      rel="noreferrer"
      onClick={() => trackEvent("whatsapp_clicked", { location: "fab" })}
      className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white pl-4 pr-5 py-3 shadow-[0_10px_30px_-8px_rgba(37,211,102,0.55)] transition-all hover:scale-[1.04]"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={1.6} />
      <span className="text-sm font-medium hidden sm:inline">Chat with us</span>
    </a>
  );
};
